import { useEffect, useState } from 'react';
import { docsApi } from './docs';
import { contractorToken } from './contractorAuth';
import { storedViewAsContractorId, storedViewAsUserId } from './viewAs';

/**
 * Help (migration 123): the staff Help space, on Documentation's engine.
 *
 * The same calls as Documentation (lib/docs's docsApi: the app's own
 * sign-in, a portal token, View as), to /help/*. The server decides who
 * reads and who edits (lib/docs-access.js); this only asks.
 */
export const helpApi = docsApi;

let cached = null;
let inflight = null;
const listeners = new Set();
const whoKey = () => `${contractorToken() ? 't' : 's'}:${storedViewAsContractorId() || ''}:${storedViewAsUserId() || ''}`;

/**
 * GET /help/me, shared: { ready, can_read, can_edit, is_admin, space_id }.
 * Null until known. The bar offers Help to whoever may read it - every
 * member of staff, once 123 is in - and to an administrator before then
 * (the page says which migration to run).
 */
export function fetchHelpMe({ force = false } = {}) {
  const who = whoKey();
  if (!force && cached && cached.for === who) return Promise.resolve(cached);
  if (!force && inflight) return inflight;
  inflight = helpApi.get('/help/me')
    .catch((e) => ({ ready: false, failed: true, switched_off: e?.response?.data?.switched_off === true }))
    .then((v) => {
      cached = { ...(v && typeof v === 'object' && !Array.isArray(v) ? v : {}), for: who };
      inflight = null;
      listeners.forEach((fn) => { try { fn(cached); } catch { /* keep going */ } });
      return cached;
    });
  return inflight;
}

export function useHelpMe(enabled = true) {
  const [v, setV] = useState(cached && cached.for === whoKey() ? cached : null);
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const on = (x) => { if (live) setV(x); };
    listeners.add(on);
    fetchHelpMe().then(on);
    return () => { live = false; listeners.delete(on); };
  }, [enabled]);
  return enabled ? v : null;
}

/** "26 Oct 2026", Malta's calendar. */
export const day = (iso) => (iso ? new Date(iso).toLocaleDateString('en-GB', {
  timeZone: 'Europe/Malta', day: 'numeric', month: 'short', year: 'numeric'
}) : '');

/** The address of a Help article; Documentation's editor for changing it. */
export const helpHref = (id) => `/help/${id}`;
export const editHref = (id) => `/docs/${id}?mode=edit`;
